import { PropertyValue } from "src/context/Property/Builder/PropertyBuilder";
import { OnUpdate } from ".";
import { FoodsCheckbox } from "@foodpilot/foods";
import { deserializeManyProperty, serializeManyProperty } from "src/context/Property/PropertyValueSerializer";
import { useState } from "react";

type CheckboxProps = {
    property: PropertyValue;
    updatePropertyValue: (options: OnUpdate) => void;
    isLocked?: boolean;
};
export const Checkbox = (props: CheckboxProps) => {
    const { property, updatePropertyValue, isLocked = false } = props;
    const options = property.property.dataList?.options;

    const values = deserializeManyProperty(property);
    const allOptionsLabel = values.value.map((i) => i.label);

    const _selectedValues = options?.filter((opt) => allOptionsLabel.includes(opt.label));
    const [selectedValues, setSelectedValue] = useState(_selectedValues);
    return (
        <FoodsCheckbox
            selectedItems={selectedValues}
            values={options ?? []}
            onChange={(selectedValues) => {
                setSelectedValue(selectedValues);

                // const labels = selectedValues.map((i) => i.label);
                const sanitizedValue = serializeManyProperty(selectedValues);
                updatePropertyValue({
                    serializedString: sanitizedValue.value,
                    dataListOptionIds: sanitizedValue.dataListOptionIds,
                    calculationType: "action",
                });
            }}
            getId={(option) => option.value}
            getName={(option) => option.label}
            CheckboxProps={{
                disabled: isLocked,
            }}
        />
    );
};
